export enum Category9Types {
    FINISHED_GOODS = 'Finished Goods'
}

export enum Category9TypeFields {
    FINISHED_GOODS = 'finishedGoods'
}
